import React, { useCallback } from 'react';
import useUI from '../hooks/useUI';
import useApp from '../hooks/useApp';
import useData from '../hooks/useData';
import textareaToHTML from '../tools/textareaToHTML';
import IconClose from '../icons/IconClose';

const ExhibitionInfo = () => {
	const { ExhibitionInfo, toggleUI } = useUI();
	const { isCHT } = useApp();
	const { basicInfo } = useData();

	const closePopup = useCallback(() => {
		toggleUI('exhibitionInfo');
	}, [toggleUI]);

	return (
		<div id='ExhibitionInfo' className={ExhibitionInfo ? 'active' : ''} >
			<div className='center-wrap'>
				<IconClose onClick={closePopup} />
				<div className='title'>{isCHT ? '展會簡介' : 'Exhibition Info'}</div>
				<div className='content' dangerouslySetInnerHTML={{ __html: isCHT ? textareaToHTML(basicInfo.introCHT) : textareaToHTML(basicInfo.introENG) }} />
			</div>
		</div>
	)
}

export default ExhibitionInfo;